import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigator from './components/Navigator'
import Home from './pages/Home';
import Leaderboard from './pages/Leaderboard';
import NotFound from './pages/NotFound'
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigator/>}>
                    <Route index element={<Home/>}/>
                    <Route path='/leaderboard' element={<Leaderboard/>}/>
                    <Route path='*' element={<NotFound/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
);
